import React from 'react';
import PropTypes from 'prop-types';
// Styles
import { Wrapper, Mark, Word } from './Logo.styles';

const Logo = ({ inverted }) => (
  <Wrapper $inverted={inverted}>
    <Mark aria-hidden='true'>
      A<em>z</em>
    </Mark>
    <Word>
      <strong>A to Z</strong>
      <span>Movie Database</span>
    </Word>
  </Wrapper>
);

Logo.propTypes = {
  inverted: PropTypes.bool
};

export default Logo;
